import { useQuery } from "react-query";
import * as OGCService from "src/services/ogc.service";
import { FeatureCollection } from "geojson";
import { ogcKeys } from "src/query-keys";

export function useWMSFeatureInfo(params: OGCService.WMSFeatureInfoParams) {
  return useQuery<FeatureCollection, Error>(ogcKeys.wmsFeatureInfo(params), () => OGCService.getWMSFeatureInfo(params));
}

export function useWFSGetFeature(params: OGCService.WFSGetFeatureParams) {
  return useQuery<FeatureCollection, Error>(ogcKeys.wfsGetFeature(params), () => OGCService.getWFSGetFeature(params));
}
